// extracted by mini-css-extract-plugin
module.exports = {"summaryPrice":"PricingDetails_summaryPrice__1XXif","summarySubtext":"PricingDetails_summarySubtext__3TeaE","membershipDivider":"PricingDetails_membershipDivider__Pqez8"};